import { useLayoutEffect } from "react";

export function usePageAlignment(navRef, ready) {
  useLayoutEffect(() => {
    const nav = navRef.current;
    const anchor = nav?.querySelector("[data-page-alignment-anchor]");
    if (!anchor) return undefined;

    const root = document.documentElement;
    const update = () => {
      if (window.innerWidth > 1024) {
        root.style.setProperty("--page-content-start", `${anchor.getBoundingClientRect().left}px`);
      }
    };
    update();
    window.addEventListener("resize", update);
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(update);
    [nav, nav.querySelector(".logo"), anchor].filter(Boolean).forEach((element) => observer?.observe(element));

    return () => {
      window.removeEventListener("resize", update);
      observer?.disconnect();
      root.style.removeProperty("--page-content-start");
    };
  }, [navRef, ready]);
}
